/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Milestone_Sessions_100Inputs */

const en_us2_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 workouts`)
};

const pt_br2_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 treinos`)
};

const es_419_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 entrenamientos`)
};

const pt_pt2_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 treinos`)
};

const fr_fr2_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 séances`)
};

const de_de2_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 Trainings`)
};

const it_it2_milestone_sessions_100 = /** @type {(inputs: Milestone_Sessions_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 allenamenti`)
};

/**
* | output |
* | --- |
* | "100 workouts" |
*
* @param {Milestone_Sessions_100Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const milestone_sessions_100 = /** @type {((inputs?: Milestone_Sessions_100Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Milestone_Sessions_100Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_milestone_sessions_100(inputs)
	if (locale === "es-419") return es_419_milestone_sessions_100(inputs)
	if (locale === "pt-PT") return pt_pt2_milestone_sessions_100(inputs)
	if (locale === "fr-FR") return fr_fr2_milestone_sessions_100(inputs)
	if (locale === "de-DE") return de_de2_milestone_sessions_100(inputs)
	if (locale === "it-IT") return it_it2_milestone_sessions_100(inputs)
	return en_us2_milestone_sessions_100(inputs)
});
export { milestone_sessions_100 as "milestone.sessions_100" }